import React, { ComponentType, createContext } from 'react';
import { Subtract } from 'utility-types';

import { UserProfileFragment } from 'api';

export const UserContext = createContext<IWithUser>({
  user: null,
});

export const UserProvider = UserContext.Provider;

export interface IWithUser {
  user: UserProfileFragment;
}

export const withUser =
  <T extends IWithUser>(Component: ComponentType<T>) =>
  (props: Subtract<T, IWithUser>) =>
    (
      <UserContext.Consumer>
        {(providerProps: IWithUser) => <Component {...(props as T)} {...providerProps} />}
      </UserContext.Consumer>
    );
